module.exports = "/images/vendor/desiigner-svg/svg/social/pinterest.svg?3bccce2201aa6a6a9aa05ff51e11acc3";